const sizeFilterOrder: string[] = [
    'Extra Extra Extra Small',
    'Extra Extra Extra Small/Extra Extra Small',
    'Extra Extra Small',
    'Extra Extra Small/Extra Small',
    'Extra Small',
    'Extra Small/Small',
    'Small',
    'Small/Medium',
    'Medium',
    'Medium/Large',
    'Large',
    'Large/Extra Large',
    'Extra Large',
    'Extra Large/Extra Extra Large',
    'Extra Extra Large',
    'Extra Extra Large/Extra Extra Extra Large',
    'Extra Extra Extra Large',
    'XXXS',
    'XXXS/XXS',
    'XXS',
    'XXS/XS',
    'XS',
    'XS/S',
    'S',
    'S/M',
    'M',
    'M/L',
    'L',
    'L/XL',
    'XL',
    'XL/XXL',
    'XXL/XXXL',
    'XXXL',
    'ONE',
    'ONE SIZE',
    'STANDARD',
    'N/A',
    'NONE',
    '5',
    '5.5',
    '6',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
    '11.5',
    '12',
    '12.5',
    '13',
    '13.5',
    '14',
    '36',
    '36.5',
    '37',
    '37.5',
    '38',
    '38.5',
    '39',
    '39.5',
    '40',
    '40.5',
    '41',
    '41.5',
    '42',
    '42.5',
    '43',
    '43.5',
    '44',
    '44.5',
    '45',
    '45.5',
    '46',
    '46.5',
    '47',
    '47.5',
    '48',
];

export function sortSizeFilterOptions(options) {
    return options.sort(function (a, b) {
        return (
            sizeFilterOrder.indexOf(a.label) - sizeFilterOrder.indexOf(b.label)
        );
    });
}

export function sizeSort(a, b) {
    return sizeFilterOrder.indexOf(a.label) - sizeFilterOrder.indexOf(b.label);
}
